<template>
    {{ dueAmount().toLocaleString() }}
</template>

<script>
export default {
    props: {
        entry: {
            type: Object,
            required: true,
        },
    },
    methods: {
        dueAmount() {
            return this.entry.amount - this.entry.waived_amount - (this.entry.paid_amount || 0)
        },
    },
}
</script>

<style scoped>

</style>
